import { enqueueSnackbar } from "notistack";
import axiosInstance from "src/utils/axios";
import localStorageAvailable from "src/utils/localStorageAvailable";

const createQrCode = async (user, data, logout) => {
  const storageAvailable = localStorageAvailable();

  const accessToken = storageAvailable
    ? localStorage.getItem("accessToken")
    : "";
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `/service/events_service/v1/events/wa/qr`,
    headers: {
      authorization: `Bearer ${accessToken}`,
      user,
    },
    data,
  };
  try {
    const response = await axiosInstance.request(config);
    return response?.data;
  } catch (error) {
    if (error?.data === "Verification timeout") {
      return;
    }
    if (error?.status === 401) {
      enqueueSnackbar("Un Authorized Request", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      logout();
    }
    enqueueSnackbar(error?.data?.message, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  }
};

export default createQrCode;
